import { Map, OrderedMap } from 'immutable';

import * as types from './types';
import { types as activityTypes, utils } from './../activity';


const initialState = Map({
  count: 0,
  results: OrderedMap({}),
  currentPage: 1,
});


const teamsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.TEAMLIST_GET.SUCCESS:
      return state.withMutations((mutable) => {
        let teams = OrderedMap();
        payload.results.forEach((team) => {
          teams = teams.set(team.id, team);
        });
        mutable.set('count', payload.count);
        mutable.set('results', teams);
      });
    case types.TEAM_REMOVE.SUCCESS:
      return state.withMutations((mutable) => {
        const teamsCount = mutable.get('count');
        mutable.set('count', teamsCount - 1);
        mutable.deleteIn(['results', `${payload}`]);
      });
    case types.TEAM_PATCH.SUCCESS:
      return state.updateIn(
        ['results', `${payload.id}`],
        (team) => ({ ...team, ...payload }),
      );
    case activityTypes.GET_TEAMS_ACTIVITY.SUCCESS: {
      const results = state.get('results');
      const entries = Object.entries(payload);
      const serializedEntries = utils.serializeTabularData(entries);

      return state.withMutations((mutable) => {
        serializedEntries
          .filter(([teamId]) => results.has(teamId))
          .forEach(([teamId, activity]) => {
            mutable.updateIn(
              ['results', teamId],
              (team) => ({ ...team, ...activity }),
            );
          });
      });
    }
    default:
      return state;
  }
};

export default teamsReducer;
